import { DocumentationValidationStatusEnum } from 'graphql-common';

export default function getValidationStatusSuccessKey(
  newStatus: DocumentationValidationStatusEnum,
) {
  if (newStatus === DocumentationValidationStatusEnum.Validated) {
    return 'validate-documents-success';
  }
  if (newStatus === DocumentationValidationStatusEnum.Rejected) {
    return 'reject-documents-success';
  }
  if (newStatus === DocumentationValidationStatusEnum.OnValidation) {
    return 'submit-documents-for-validation-success';
  }
  return 'update-document-success';
}
